import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  userTables: [],
}

const userTablesSlice = createSlice({
  name: 'userTables',
  initialState,
  reducers: {
    setUserTables: (state, action) => {
      state.userTables = action.payload
    },
  },
})

export const { setUserTables } = userTablesSlice.actions
export default userTablesSlice.reducer
